import { render, staticRenderFns } from "./documentoVenta.vue?vue&type=template&id=306feffe"
import script from "./documentoVenta.vue?vue&type=script&lang=js"
export * from "./documentoVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports